import { getUnownedCompaniesOfUserApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'unownedCompaniesOfUser';

export const getUnownedCompaniesOfUser = getAllCustom(
  MODEL_NAME,
  getUnownedCompaniesOfUserApi,
);
